<template>
  <div class="details">
    <el-container>
      <el-main ref="main">
        <el-tabs  v-model="activeName" style="width: 100%">
          <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="标题：">
                    <el-input v-model="dataForm.projectName" placeholder="请输入标题" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="发文字号：">
                    <el-input v-model="dataForm.projectName" placeholder="请输入发文字号" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="发文分类：">
                    <el-select v-model="dataForm.projectName" placeholder="请选择发文分类">
                      <el-option value="1">123</el-option>
                      <!--                    <el-option :label="deptItem.applyDeptName" :value="deptItem.applyDeptId" v-for="(deptItem,deptIndex) in deptList" :key="'deptItem'+deptIndex"></el-option>-->
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="发文日期：">
                    <el-date-picker
                        v-model="dataForm.projectName"
                        type="date"
                        placeholder="请选择发文日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="附件" name="Tab2" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="12">
                  <el-form-item label-width="120px" label="内容：">

                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="审批信息" name="Tab3" style="height: 700px;overflow-y: auto">

          </el-tab-pane>
        </el-tabs>
      </el-main>
      <el-footer class="container">
        <div class="btnMid">
          <el-button type="info" @click="reset()">关闭</el-button>
        </div>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "details",
  data(){
    return {
      activeName: 'Tab1',
      dataForm: {
        projectName: "",
      }
    }
  },
  methods: {
    //关闭
    reset() {

    }
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  .details {
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    .container{
      width: 900px;
    }
  }
  /deep/.el-container .el-main{
    height: 100%;
  }
  /deep/.el-textarea{
    width: 600px;
  }
  /deep/.el-tabs__header{
    padding-right: 0 !important;
    .el-tabs__nav-wrap{
      padding-left: 30px;
    }
  }
  /deep/.el-input.is-disabled .el-input__inner{
    background-color: #fff !important;
    color: #606266 !important;
  }
  .btnMid {
    width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }
</style>